import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { map } from 'rxjs/operators';
import { getPaymentTermWithPreloadedOrder } from '../../selectors/one-click-payments.selector';
import { OneClickBuilderField } from '../../util/constants/builder-fields';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { filter } from 'rxjs/operators';

@Injectable()
export class OneClickPaymentsLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup, config?: FieldConfig): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getPaymentTermWithPreloadedOrder(config['at'])),
      filter(({ payments }) => !!payments),
      map(({ payments, preloadedOrder }) => {
        if (preloadedOrder) {
          const payment = payments.find(
            (paymentTerm) => paymentTerm.paymentTermId === preloadedOrder.items[config['at']].paymentTerm.paymentTermId,
          );
          payment && formGroup.controls[OneClickBuilderField.Payment].setValue(payment.paymentTermId);
        }
        return payments.map((payment) => {
          return {
            id: payment.paymentTermId,
            name: payment.paymentTermType.paymentTermTypeDesc,
          };
        });
      }),
    );
  }
}
